<script setup lang="ts">
interface Props {
  escClose?: boolean;
  focusAfterClosed?: HTMLElement | null;
  initialFocus?: HTMLElement | null;
  closeDisabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  escClose: false,
  closeDisabled: false
})

const { closeDisabled } = toRefs(props)
const { escClose } = props

interface Emits {
  (e: 'close'): void;
}

const emits = defineEmits<Emits>()

const close = () => {
  !closeDisabled.value && emits('close')
}

onBeforeMount(() => {
  const bodyOverflow = document.body.style.overflow
  const bodyPaddingRight = document.body.style.paddingRight

  const scrollbarWidth = window.innerWidth - document.body.clientWidth

  document.body.style.overflowY = 'hidden'
  document.body.style.paddingRight = `${scrollbarWidth}px`

  onBeforeUnmount(() => {
    document.body.style.overflowY = bodyOverflow
    document.body.style.paddingRight = bodyPaddingRight
  })
})

escClose && useEventListener(window, 'keyup', (event: KeyboardEvent) => {
  const key = event.which || event.keyCode
  if (key !== 27) {
    return
  }

  event.preventDefault()
  event.stopPropagation()
  close()
})

provide(DialogInjection, {
  close
})

defineExpose({
  close
})
</script>

<template>
  <FocusTrap
    aria-modal="true"
    role="dialog"
    :focus-after-closed="focusAfterClosed"
    :initial-focus="initialFocus"
    class="fixed inset-0 z-50 w-full h-full overflow-auto p-[10px] pl-[calc(10px+100vw-100%)]"
  >
    <slot v-bind="{ close }" />
  </FocusTrap>
</template>